"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GoodImageTypes = _interopRequireDefault(require("./GoodImageTypes"));

var _default = Object.freeze([_GoodImageTypes.default.MODULE_IMAGE_1, _GoodImageTypes.default.MODULE_IMAGE_2, _GoodImageTypes.default.MODULE_IMAGE_3, _GoodImageTypes.default.MODULE_IMAGE_4, _GoodImageTypes.default.MODULE_IMAGE_5]);

exports.default = _default;
module.exports = exports.default;